import React, { createContext } from 'react';
import { useTabs, TabProps, Tab as _Tab } from './hooks/useTabs';
export type Tab = _Tab;

export const TabContext = createContext<{
  updateTab: (newTab: string, shouldPersist?: boolean) => void;
}>({
  updateTab: () => {},
});

/**
 * Tabs component. This component is commonly used to add
 * another layer of navigation to a page.
 *
 * ## Basic Usage
 *
 * @example
 *
 * ```tsx
 * import { Tabs } from 'js/design_system/Tabs';
 *
 * <Tabs
 *   tabs={[
 *     { key: 'tab1', renderTitle: () => 'Tab 1', render: () => <p>Tab 1 content</p> },
 *     { key: 'tab2', renderTitle: () => 'Tab 2', render: () => <p>Tab 2 content</p> },
 *   ]}
 *   header={<h1>Extra header content</h1>}
 *   persistMode='query-param'
 *   renderMode='active'
 * />
 * ```
 */
export const Tabs: React.FC<TabProps> = (props) => {
  const { header, content, updateTab } = useTabs(props);

  return (
    <TabContext.Provider value={{ updateTab }}>
      {header}
      {content}
    </TabContext.Provider>
  );
};
